import { BrowserRouter as Router, Switch } from "react-router-dom";
import Home from "./components/home/Home";
import Page from "./components/routing/Page";
import Routes from "./components/routing/Routes";
import ScrollToTop from "./components/scrollToTop";
import { ToastContainer } from "react-toastify";
import { cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  collapse: false,
});

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover={false}
          transition={Zoom}
        />
        <Switch>
          <Page exact path="/" component={Home} title="Pixlip" />
          <Routes />
        </Switch>
      </Router>
    </>
  );
}

export default App;
